// dashboard 首页相关api
import request from '@/utils/request'

// 获取用户注册
export function reqMemberCount() {
  return request({
    url: '/admin/index/memberCount',
    method: 'post'
  })
}
// 获取企业注册
export function reqCompanyAccountCount() {
  return request({
    url: '/admin/index/companyCount',
    method: 'post'
  })
}
// 最近已发布职位
export function reqJobCount() {
  return request({
    url: '/admin/index/jobCount',
    method: 'post'
  })
}

// 投递简历记录
export function reqSendResumeCount() {
  return request({
    url: '/admin/index/memberSendResumeRecordCount',
    method: 'post'
  })
}
